<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="交易时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="交易单号">
            <el-input
              class="search-input"
              v-model="orderId"
              placeholder="交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              v-if="!isInstitution"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
            <el-input
              class="search-input"
              v-model="merchantId"
              placeholder="请输入商户编号"
              v-else
              clearable></el-input>
          </el-form-item>
          <el-form-item label="商户交易单号">
            <el-input
              style="width:160px;"
              v-model="merchantOrderId"
              placeholder="商户交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="交易类型">
            <el-select style="width:120px;" v-model="payType" placeholder="交易类型" @change="payTypeSelectChange">
              <el-option label="扫码" :value="0"></el-option>
              <el-option label="非扫码" :value="1"></el-option>
            </el-select>
            <el-select v-model="payChannel" collapse-tags multiple placeholder="交易渠道">
              <template v-if="payType === 1">
                <el-option label="刷卡" :value="0"></el-option>
              </template>
              <template v-else>
                <el-option label="微信" :value="1"></el-option>
                <el-option label="支付宝" :value="2"></el-option>
                <el-option label="银联二维码" :value="5"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select style="width:120px;" v-model="statusType" clearable placeholder="交易状态" @change="statusTypeSelectChange">
              <el-option label="交易 " :value="0"></el-option>
              <el-option label="退款" :value="1"></el-option>
              <el-option label="预授权" :value="2" v-show="payType === 1"></el-option>
            </el-select>
            <el-select v-model="status" collapse-tags multiple clearable placeholder="请先选择交易状态类型">
              <template v-if="statusType === 0">
                <el-option label="交易初始" :value="0"></el-option>
                <el-option label="支付成功" :value="1"></el-option>
                <el-option label="支付失败" :value="2"></el-option>
                <el-option label="订单关闭" :value="6"></el-option>
                <el-option label="冲正成功" :value="7"></el-option>
              </template>
              <template v-if="statusType && statusType === 1">
                <el-option label="退款成功" :value="3"></el-option>
                <el-option label="退款失败" :value="4"></el-option>
                <el-option label="退款中" :value="5"></el-option>
              </template>
              <template v-if="statusType && statusType === 2">
                <el-option label="预授权成功" :value="8"></el-option>
                <el-option label="预授权失败" :value="9"></el-option>
                <el-option label="预授权撤销成功" :value="10"></el-option>
                <el-option label="预授权撤销失败" :value="11"></el-option>
                <el-option label="预授权完成成功" :value="12"></el-option>
                <el-option label="预授权完成失败" :value="13"></el-option>
                <el-option label="预授权完成通知成功" :value="14"></el-option>
                <el-option label="预授权完成通知失败" :value="15"></el-option>
                <el-option label="预授权完成撤销成功" :value="16"></el-option>
                <el-option label="预授权完成撤销失败" :value="17"></el-option>
                <el-option label="预授权冲正成功" :value="18"></el-option>
                <el-option label="预授权冲正失败" :value="19"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="订单金额(元)" v-if="!isInstitution">
            <el-input
              style="width:100px;"
              v-model="minAmount"
              auto-complete="off"
              placeholder="正整数"></el-input> -
            <el-input
              style="width:100px;"
              v-model="maxAmount"
              auto-complete="off"
              placeholder="正整数"></el-input>
          </el-form-item>
          <el-form-item label="机构编号" v-if="isInstitution">
            <el-input
              class="search-input"
              v-model="searchInfo.customerId"
              placeholder="请输入机构编号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="一代编号" v-if="isInstitution">
            <el-input
              class="search-input"
              v-model="searchInfo.agentId"
              placeholder="请输入一级代理商编号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" plain icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              icon="el-icon-download"
              opt="export"
              plain
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <div class="search-tips">说明：导出最大支持100000条数据</div>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 结算记录table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="dealInfoList"
        size="medium"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="transTime"
          label="交易时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="forderId"
          label="交易单号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fmerchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fmerchantOrderId"
          label="商户交易单号"
          align="center"
          min-width="200"
          v-if="!isInstitution">
          <template slot-scope="scope">
            <div>{{ scope.row.fmerchantOrderId || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerId"
          label="机构编号"
          align="center"
          min-width="200"
          v-if="isInstitution">
        </el-table-column>
        <el-table-column
          prop="paymentType"
          label="交易类型"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="paymentSourceStr"
          label="交易终端"
          align="center"
          min-width="200"
          v-if="!isInstitution">
          <template slot-scope="scope">
            <span>{{ scope.row.paymentSourceStr || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="交易状态"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="orderAmountStr"
          label="订单金额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="couponAmountStr"
          label="优惠金额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="buyerPayAmountStr"
          label="实付金额"
          min-width="150"
          align="center">
        </el-table-column>
        <el-table-column
          prop="settleAmountStr"
          label="应结订单金额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="frefundId"
          label="退款订单号"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.frefundId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fmerchantRefundId"
          label="商户退款订单号"
          align="center"
          min-width="150"
          v-if="!isInstitution">
          <template slot-scope="scope">
            <span>{{ scope.row.fmerchantRefundId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isWoWoAgent && !isInstitution"
          prop="fMerchantSubsidy"
          label="手续费补贴"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          v-if="isWoWoAgent && !isInstitution"
          prop="fUserSubsidy"
          label="营销补贴"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="attach"
          label="备注"
          min-width="300"
          align="center"
          v-if="!isInstitution">
          <template slot-scope="scope">
            <span>{{scope.row.attach || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="posNo"
          label="机器SN"
          min-width="300"
          align="center"
          v-if="!isInstitution">
          <template slot-scope="scope">
            <span>{{scope.row.posNo || '-'}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { listAgentMerchant, listDealInfo, exportDealInfo, listTradeDetail, exportTradeDetail } from '@/api/transaction'
const selectFn = {
  listDealInfo, exportDealInfo, listTradeDetail, exportTradeDetail
}
export default {
  name: 'TradeDataInfo', // 代理商交易流水查询
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = this.$store.getters.roleId === 10 ? new Date(new Date().setDate(1)) : new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: '',
        orderId: '',
        merchantOrderId: '',
        payType: '',
        paymentChannels: '',
        statusType: '',
        status: '',
        minAmount: '',
        maxAmount: '',
        agentType: '',
        customerId: '',
        agentId: ''
      },
      creatTime: [todayZeroStr, todayStr],
      merchantId: '',
      orderId: '',
      merchantOrderId: '',
      payType: 0,
      payChannel: [1, 2, 5],
      maxAmount: '',
      minAmount: '',
      statusType: 0,
      status: [0, 1, 2, 6, 7],
      tableLoading: false,
      selectLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      dealInfoList: [],
      isWoWoAgent: false,
      isInstitution: this.$store.getters.roleId === 10
    }
  },
  watch: {
    payChannel (val, oldVal) {
      // 如果是窝窝代理商，不能同时选中扫码和云闪付
      if (this.isWoWoAgent) {
        if (oldVal.includes(5) && (val.includes(1) || val.includes(2)) && val.includes(5)) {
          const index = oldVal.indexOf(5)
          this.payChannel.splice(index, 1)
        }
        if ((oldVal.includes(1) || oldVal.includes(2)) && val.includes(5)) {
          this.payChannel = [5]
        }
      }
    }
  },
  mounted () {
    // this.getDefaultData()
    if (['5387968', '1515509'].includes(this.$store.getters.userId)) {
      this.isWoWoAgent = true
      this.searchInfo.agentType = this.$store.getters.userId.substr(0, 3)
      this.payChannel = [1, 2]
    } else {
      this.isWoWoAgent = false
    }
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {Object} value 当前结果
     */
    onChangeCurrentPage (value) {
      this.paginations.pageNo = value
      this.searchClick(true)
    },
    validAmount () {
      var num = /^[0-9]+$/
      if (this.minAmount !== '' && (!num.test(this.minAmount))) {
        this.minAmount = ''
        this.$message({
          showClose: true,
          message: '交易金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.maxAmount !== '' && (!num.test(this.maxAmount))) {
        this.maxAmount = ''
        this.$message({
          showClose: true,
          message: '交易金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.minAmount !== '' && this.maxAmount !== '') {
        if (parseInt(this.minAmount) > parseInt(this.maxAmount)) {
          this.maxAmount = ''
          this.$message({
            showClose: true,
            message: '最大交易金额不能小于最小金额',
            type: 'warning'
          })
          return false
        }
      }
      return true
    },
    /**
     * 交易类型选择change
     */
    payTypeSelectChange (value) {
      if (value === 0) {
        this.payChannel = [1, 2, 5]
        if (this.statusType === 2) {
          this.statusType = 0
          this.statusTypeSelectChange(0)
        }
      }
      if (value === 1) {
        this.payChannel = [0]
      }
    },
    /**
     * 交易状态选择change
     */
    statusTypeSelectChange (value) {
      if (!value && value !== 0) {
        this.status = []
      }
      if (value === 0) {
        this.status = [0, 1, 2, 6, 7]
      }
      if (value === 1) {
        this.status = [3, 4, 5]
      }
      if (value === 2) {
        this.status = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
      }
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      if (!this.merchantId && !this.orderId && !this.isInstitution) {
        this.$message({
          message: '请先输入交易单号或商户编号',
          type: 'warning'
        })
        return
      }
      if (!this.searchInfo.customerId && this.isInstitution) {
        this.$message({
          message: '请先输入机构编号',
          type: 'warning'
        })
        return
      }
      if (this.creatTime.length === 0 || !this.creatTime[0] || !this.creatTime[1]) {
        this.$message({
          message: '请筛选时间进行查询',
          type: 'error'
        })
        return
      }
      // if (this.isInstitution && (new Date(this.creatTime[1]) - new Date(this.creatTime[0])) / (60 * 60 * 24 * 1000) >= 31) {
      //   this.$message({
      //     message: '请选择31天内数据进行筛选',
      //     type: 'error'
      //   })
      //   return
      // }
      if (this.isInstitution && this.creatTime[1].substring(0, 8) !== this.creatTime[0].substring(0, 8)) {
        this.$message({
          showClose: true,
          message: '目前仅支持查询一个月内数据，不能跨月查询，请检查后重试',
          type: 'error'
        })
        return
      }
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(noReset)
      this.listDealInfo()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      if (!this.merchantId && !this.orderId && !this.isInstitution) {
        this.$message({
          message: '请先输入交易单号或商户编号',
          type: 'warning'
        })
        return
      }
      if (!this.searchInfo.customerId && this.isInstitution) {
        this.$message({
          message: '请先输入机构编号',
          type: 'warning'
        })
        return
      }
      if (this.isInstitution && (this.creatTime.length === 0 || !this.creatTime[0] || !this.creatTime[1])) {
        this.$message({
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      if (this.isInstitution && (new Date(this.creatTime[1]) - new Date(this.creatTime[0])) / (60 * 60 * 24 * 1000) >= 31) {
        this.$message({
          message: '请选择31天内数据进行导出',
          type: 'error'
        })
        return
      }
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 32) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportDealInfo()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.minAmount = this.minAmount || ''
      this.searchInfo.maxAmount = this.maxAmount || ''
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.orderId = this.orderId.replace(/ /g, '') || ''
      this.searchInfo.merchantOrderId = this.merchantOrderId.replace(/ /g, '') || ''
      this.searchInfo.payType = this.payType
      this.searchInfo.paymentChannels = this.payChannel.join(',')
      this.searchInfo.statusType = this.statusType
      this.searchInfo.status = this.status.join(',')
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.creatTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
     * 获取代理商下所有商户列表
     */
    listAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      console.log(params)
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          console.log('listAgentMerchant response:', response)
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
          this.loading = false
        })
      })
    },
    /**
     * 交易数据查询
     */
    listDealInfo () {
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 32) {
      //   this.$message({
      //     message: '请筛选1个月内的交易进行查询',
      //     type: 'error'
      //   })
      //   return
      // }
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      const url = this.isInstitution ? 'listTradeDetail' : 'listDealInfo'
      selectFn[url](params).then(response => {
        console.log('listDealInfo response:', response)
        this.loading = false
        if (parseInt(response.result_cde) === 0) {
          this.dealInfoList = response.list
          this.paginations.count = response.totalCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 交易数据查询导出
     */
    exportDealInfo () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 1,
        moduleName: '交易',
        menuName: '交易流水'
      }))
      console.log(params)
      const url = this.isInstitution ? 'exportTradeDetail' : 'exportDealInfo'
      selectFn[url](params).then(response => {
        this.exportButtonLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {},
  filters: {
    formatFState (value) {
      switch (value) {
        case 0:
          return '初始化状态'
        case 1:
          return '金额冻结成功'
        case 2:
          return '金额冻结失败'
        case 3:
          return '冻结结果未知'
        case 4:
          return '商户打款被冻结'
        case 5:
          return '被拦截<未发起付款>'
        case 6:
          return '打款中'
        case 14:
          return '金额解冻结果未知'
        case 15:
          return '退票成功'
        case 16:
          return '退票失败'
        case 17:
          return '退票结果未知'
        case 18:
          return '打款单被合并'
        case 19:
          return '提交打款失败，允许重新打款'
        case 20:
          return '申请退票'
        case 7:
          return '付款成功'
        case 8:
          return '付款失败'
        case 9:
          return '金额解冻转账成功'
        case 10:
          return '金额解冻转账失败'
        case 11:
          return '金额解冻转账结果未知'
        case 12:
          return '金额解冻成功'
        case 13:
          return '金额解冻失败'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
</style>
